import './slider.css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSliders } from '../../acciones/index';



export const Slider = () => {

    const dispatch = useDispatch();
    const sliders = useSelector((state) => state.sliders);

    useEffect(() => {
        dispatch(getSliders());
    }, [dispatch]);


    return (
        <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
            <div className="carousel-inner">
                {sliders.length > 0 ? (
                    sliders.map((slider, index) => (
                        <div
                            key={slider.slider_id}
                            className={`carousel-item ${index === 0 ? 'active' : ''}`}
                        >
                            <a href={`/InfoProyectos/${slider.proyecto_id}`}><img src={slider.imagen} className="d-block w-100" alt={slider.titulo} /></a>
                            <div className="carousel-caption d-none d-md-block text-light">
                                <h5>{slider.titulo}</h5>
                                <p>{slider.informacion}</p>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="carousel-item active">
                        <p>Cargando sliders...</p>
                    </div>
                )}
            </div>
            <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleAutoplaying"
                data-bs-slide="prev"
            >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleAutoplaying"
                data-bs-slide="next"
            >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    )
}


